class profileNavigation {

    constructor() {
        this.$container = $('#profileNavigation');
        this.$openButton = $('#profileNavigation__open');
        this.$closeButton = $('#profileNavigation__toggle');
        this.createOverlay(this.$container);
        // this.events();
        this.openControl();
    }

    // open navigation
    open() {
        this.$container.addClass('isActive');
        this.$overlay.stop().fadeIn();
        hideSearch();
        hideShare();
        pageNav.hideSubNav();
    }

    // close navigation
    close() {
        let that = this;
        that.$container.removeClass('isActive');
        that.$overlay.stop().fadeOut();
    }

    // check if is open
    isOpen() {
        return this.$container.hasClass('isActive');
    }

    // check if is mobile view
    isMobile() {
        return $(window).width() < 992;
    }

    // add nav overlay to page
    createOverlay($parent) {
        let $elm = $('<div>');
        $elm
            .addClass('profileNavigation__overlay')
            .attr('id', 'profileNavigation__overlay');

        $parent.parent().append($elm);
        this.$overlay = $elm;
    }

    // events
    openControl() {
        let that = this;

        var hoverTimeout;
        that.$openButton.hover(function () { //hover
            if (!that.isMobile()) { //work only on desktop
                if (!$('.pageSearch').hasClass('isActive') && !$('.pageShare').hasClass('isActive')) { //show only if page search and page search is not active
                    if (!that.$container.hasClass('isActive')) { //if navigation is not open set timer to delay and try open
                        clearTimeout(hoverTimeout);
                        var $this = $(this);
                        hoverTimeout = setTimeout(function () {
                            that.open();
                        }, 300);
                    }
                }
            }
        }, function () {
            if (!that.isMobile()) { //work only on desktop
                if ($(this).hasClass('hasSub')) { //if item has subMenu
                    if (!that.$container.hasClass('isActive')) { //if navigation is not open but hover is out clear timer to disable navigation to open
                        clearTimeout(hoverTimeout);
                    }
                }
            }
        });

        // hide navigation on hover on nav overlay
        that.$overlay.hover(function () {
            if (!that.isMobile()) { //work only on desktop
                if (that.$container.hasClass('isActive')) {
                    that.close();
                }
            }
        });

        that.$openButton.on('click', function (e) {
            e.preventDefault();
            if (that.isOpen()) {
                that.close();
            } else {
                that.open();
            }
        });

        that.$closeButton.on('click', function () {
            that.close();
        });

        that.$overlay.on('click', function () {
            that.close();
        });
    }
}

let profileNav = new profileNavigation();